import { CallBackProps } from 'react-joyride';

export const useStartCourseTutorial = () => {
  const handleCallback = (data: CallBackProps) => {
    data;
  };

  return { handleCallback };
};
